
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/[goalUID]/planner",
      function () {
        return require("private-next-pages/goal/[goalSlug]/[goalUID]/planner.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goal/[goalSlug]/[goalUID]/planner"])
      });
    }
  